export default __webpack_public_path__ + "static/media/blogpost-2-cards.0588aca1.jpg";